export default function Speaker() {
    return (
        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_608_33132)">
                <path
                    d="M23.2861 25.8817L23.2861 8.52691C23.2861 7.68119 22.6005 6.99561 21.7548 6.99561L12.567 6.99561C11.7213 6.9956 11.0357 7.6812 11.0357 8.52691L11.0357 25.8817C11.0357 26.7274 11.7213 27.413 12.567 27.413L21.7548 27.413C22.6005 27.413 23.2861 26.7274 23.2861 25.8817Z"
                    stroke="black"
                    strokeWidth="1.22505"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M25.3281 19.9439V14.313" stroke="black" strokeWidth="1.22505" strokeMiterlimit="10" strokeLinecap="round" />
                <path d="M4.91016 19.9439V14.313" stroke="black" strokeWidth="1.22505" strokeMiterlimit="10" strokeLinecap="round" />
                <path d="M27.3701 22.1453V12.1001" stroke="black" strokeWidth="1.22505" strokeMiterlimit="10" strokeLinecap="round" />
                <path d="M6.95215 22.1453V12.1001" stroke="black" strokeWidth="1.22505" strokeMiterlimit="10" strokeLinecap="round" />
                <path d="M29.4111 20.1606V14.4194" stroke="black" strokeWidth="1.22505" strokeMiterlimit="10" strokeLinecap="round" />
                <path d="M8.99414 20.1606V14.4194" stroke="black" strokeWidth="1.22505" strokeMiterlimit="10" strokeLinecap="round" />
                <circle cx="17.1609" cy="17.2043" r="2.04174" stroke="black" strokeWidth="1.22505" />
                <circle cx="17.1606" cy="17.2046" r="4.08348" stroke="black" strokeWidth="1.22505" />
            </g>
            <defs>
                <clipPath id="clip0_608_33132">
                    <rect width="32.6679" height="32.6679" fill="white" transform="translate(0.827148 0.870605)" />
                </clipPath>
            </defs>
        </svg>
    );
}
